import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0011',
    ecrans: ['00-2'],
    params:['?lcrcleint']
});
